'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TooltipVisibilityProvider: function() {
        return TooltipVisibilityProvider;
    },
    useTooltipVisibility: function() {
        return useTooltipVisibility;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
/**
 * @internal
 * Context shared by all of the tooltips in the app
 */ const TooltipVisibilityContext = _react.createContext(undefined);
const tooltipVisibilityContextDefaultValue = {};
const TooltipVisibilityProvider = TooltipVisibilityContext.Provider;
function useTooltipVisibility() {
    var _React_useContext;
    return (_React_useContext = _react.useContext(TooltipVisibilityContext)) !== null && _React_useContext !== void 0 ? _React_useContext : tooltipVisibilityContextDefaultValue;
}
